export const eventInfo = {
  name: 'Sona Nalam Nova 2026',
  tagline: 'Innovating Healthcare, Together',
  description: 'Sona Nalam Nova 2026 is a premier medical innovation hackathon hosted by Sona College of Technology, Salem in association with the Indian Medical Association (IMA), Salem. Bringing together healthcare professionals, engineers, designers, and students to tackle real-world medical challenges over 2 days.',
  date: 'September 25-26, 2026',
  venue: 'Sona College of Technology, Salem',
  totalPrizePool: '₹5,00,000',
  duration: '2 Days',
  registrationDeadline: 'September 1, 2026',
};

export const faqs = [
  {
    question: 'Who can participate in Sona Nalam Nova 2026?',
    answer: 'Sona Nalam Nova 2026 is open to undergraduate and postgraduate students from medical, engineering, and science disciplines across India. Teams must consist of 3-4 members from the same college.',
  },
  {
    question: 'What is the registration fee?',
    answer: 'The registration fee is ₹2,000 per team. This covers access to all hackathon resources, meals during the event, mentorship sessions, and a participant kit.',
  },
  {
    question: 'Do we need to bring our own equipment?',
    answer: 'Yes, participants should bring their own laptops and any specific hardware needed for their project. We provide high-speed WiFi, power outlets, and basic prototyping supplies.',
  },
  {
    question: 'Is accommodation provided?',
    answer: 'Basic accommodation is available on campus for outstation teams on a first-come, first-served basis. Details will be shared after registration confirmation.',
  },
  {
    question: 'What if I don\'t have a team?',
    answer: 'All participants must register as a team of 3-4 members. We encourage you to form a team before registering.',
  },
  {
    question: 'Is a faculty mentor mandatory?',
    answer: 'No, having a faculty mentor is optional but encouraged. A mentor can provide valuable guidance during the preparation phase and at the event.',
  },
];